
import {of as observableOf } from 'rxjs';

import {switchMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { InvitedeskApiService } from '@shared/services/api/legacy/invitedesk-api.service';
import { AppActionTypes } from '@state/actions/app/app.actions';
import { AuthActionTypes } from '@state/actions/auth/auth.actions';

@Injectable()
export class AuthEffects {
    constructor(private actions$: Actions, private inviteDeskApi: InvitedeskApiService) { }

    public logOut$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActionTypes.LOG_OUT),
            switchMap(() => observableOf({ type: AppActionTypes.CLEAR_PROFILE }))
        ));
}
